import { EnumValue } from './EnumValue'

class MyEnum {
  // get enumList() {
  //   return Object.values(this)
  //     .filter(value => value instanceof EnumValue)
  // }

  static get enumArray() {
    return Object.values(this)
      .filter(value => value instanceof EnumValue)
  }

  static get codeArray() {
    return this.enumArray.map(value => value.code)
  }

  static get codeNameMap() {
    return this.enumArray.reduce((result, item) => {
      result[item.code] = item.name

      return result
    }, {})
  }
}

export default MyEnum
